import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../styling/templates.css";

const ZoomImage = ({
  imageUrl1,
  imageUrl2,
  imageUrl3,
  imageUrl4,
  imageUrl5,
  imageUrl6,
  imageUrl7,
  imageUrl8,
  itemNumber,
}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isZoomed, setIsZoomed] = useState(false);
  const [offsetX, setOffsetX] = useState(0);
  const [offsetY, setOffsetY] = useState(0);
  const [isHoveringIcon, setIsHoveringIcon] = useState(false);

  const handleThumbnailClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleMouseEnter = () => {
    setIsZoomed(!isHoveringIcon);
  };

  const handleMouseLeave = () => {
    setIsZoomed(false);
  };

  const handleIconMouseEnter = () => {
    setIsHoveringIcon(true);
  };

  const handleIconMouseLeave = () => {
    setIsHoveringIcon(false);
  };

  const handleMouseMove = (e) => {
    if (!isZoomed) return;
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - left) / width;
    const y = (e.clientY - top) / height;
    setOffsetX(x);
    setOffsetY(y);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const images = [
    imageUrl1,
    imageUrl2,
    imageUrl3,
    imageUrl4,
    imageUrl5,
    imageUrl6,
    imageUrl7,
    imageUrl8,
  ];

  return (
    <div>
      <div
        className="zoom-image-container"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
      >
        <div
          className={`zoom-image-wrapper ${isZoomed ? "zoomed" : ""}`}
          style={{ transformOrigin: `${offsetX * 100}% ${offsetY * 100}%` }}
        >
          <img
            className="zoom-image"
            src={images[selectedImageIndex]}
            alt="Zoomable"
          />
        </div>

        <div
          className={`hand-lens-icon ${isZoomed ? "hidden" : ""}`}
          onClick={openModal}
          onMouseEnter={handleIconMouseEnter}
          onMouseLeave={handleIconMouseLeave}
        >
          <FontAwesomeIcon icon={faSearch} />
        </div>
      </div>
      {isModalOpen && (
        <div className="modal">
          <div className="close-icon" onClick={closeModal}>
            <FontAwesomeIcon icon={faTimes} />
          </div>
          <div className="modal-content">
            <img
              className="modal-image"
              src={images[selectedImageIndex]}
              alt="Zoomable"
            />
          </div>
          <div className="item-number">{itemNumber}</div>
        </div>
      )}
      <div
        className={`image-thumbnails ${isZoomed ? "thumbnails-visible" : ""}`}
      >
        {images[1] &&
          images.map((imageUrl, index) =>
            imageUrl ? (
              <img
                key={index}
                className={`thumbnail ${
                  index === selectedImageIndex ? "selected" : ""
                }`}
                src={imageUrl}
                alt={`Thumbnail ${index}`}
                onClick={() => handleThumbnailClick(index)}
              />
            ) : null
          )}
      </div>
    </div>
  );
};

export default ZoomImage;
